import { useQuery } from "@tanstack/react-query";
import { PassChangeReason } from "../models/PassChangeReason";
import { getPassChangeReasons } from "../repositories/PassChangeReasonsRepository";

export const PASS_CHANGE_REASONS_QUERY_KEYS = {
	all: ["passChangeReasons"] as const,
	list: () => ["passChangeReasons", "list"] as const,
	byId: (id: number | null) => ["passChangeReasons", "detail", id] as const,
};

export const usePassChangeReasons = () => {
	return useQuery<PassChangeReason[], Error>({
		queryKey: PASS_CHANGE_REASONS_QUERY_KEYS.list(),
		queryFn: () => getPassChangeReasons(),
	});
};
